import { createRouter, createWebHistory } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { adminUsers } from './config';
import HomePage from '@/components/HomePage.vue';
import AdminPanel from '@/views/AdminPanel.vue';
import ArticlePage from '@/components/ArticlePage.vue';
import LoginView from '@/views/Login.vue';

const routes = [
  { path: '/', redirect: '/en' },
  { path: '/:lang', component: HomePage },
  { path: '/login', component: LoginView },
  { 
    path: '/admin', 
    component: AdminPanel,
    meta: { requiresAuth: true }
  },
  { path: '/:lang/article/:slug', component: ArticlePage, name: 'ArticlePage' }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Global promise to ensure Firebase Auth state is initialized once
let firebaseAuthReadyResolver;
const firebaseAuthReadyPromise = new Promise(resolve => {
  firebaseAuthReadyResolver = resolve;
});

// Initialize the Firebase Auth state listener once, early in the app lifecycle
onAuthStateChanged(getAuth(), (user) => {
  // console.log("Firebase Auth state initialized:", user ? user.email : "no user"); // Debugging
  firebaseAuthReadyResolver(user); // Resolve the promise with the initial user state
});

// A simpler getCurrentUser that now just returns the currently logged-in user
// after firebaseAuthReadyPromise has resolved.
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // Always wait for Firebase Auth to be initialized before making any auth decisions
  await firebaseAuthReadyPromise; 

  const user = getAuth().currentUser; // Get the current user *after* auth is ready
  const isAuthenticated = !!user;
  const isAdmin = isAuthenticated && user && adminUsers.includes(user.email); // Check user exists before accessing email

  // console.log(`Navigating to: ${to.path}, Requires Auth: ${requiresAuth}, Is Authenticated: ${isAuthenticated}, Is Admin: ${isAdmin}`); // Debugging

  if (requiresAuth) {
    if (isAdmin) {
      next();
    } else {
      console.log('User not authorized to access admin route. Redirecting to login.');
      if (to.path !== '/login') { // Only redirect if not already on login page
        next('/login');
      } else {
        next(); // Already on login page, allow access to prevent loop
      }
    }
  } else {
    // If user is authenticated and tries to go to login page, redirect to admin
    if (isAuthenticated && to.path === '/login') {
      console.log('Authenticated user trying to access login page. Redirecting to admin.');
      next('/admin');
    } else {
      next(); // Allow public access
    }
  }
});

export default router;
